import { settings } from '../../settings';
import Fetch from '../../utils/fetch';
import { EditUser, UpdateResult } from './EditAdminUserModal';

export async function postUpdateUser(
  user: EditUser,
  emailVerified?: boolean
): Promise<UpdateResult> {
  try {
    const newEmail = (user.newEmail || '').trim();

    const res = await Fetch.put({
      url: `${settings.newApiUrl}/user`,
      body: {
        ...user,
        newEmail: newEmail || undefined,
        emailVerified:
          user.emailVerified !== emailVerified ? user.emailVerified : undefined,
      },
    });

    if (res.ok) {
      return { success: true, errors: [] };
    } else if (res.status === 422) {
      return {
        success: false,
        errors: (await res.json()).map((msg: { message: string }) => ({
          message: msg.message,
        })),
      };
    } else {
      return {
        success: false,
        errors: [
          {
            message: 'Something went wrong. The user could not be updated',
          },
        ],
      };
    }
  } catch (e) {
    return {
      success: false,
      errors: [
        {
          message: 'Something went wrong. The user could not be updated',
        },
      ],
    };
  }
}
